import React from 'react';
import { Modal } from 'antd-mobile';
import { closeWindow } from '../../../utils/weixin';
import './index.scss';
export const AuthPrompt = props => {
	return (
		// props.isShowAuthPrompt
		<Modal
			visible={true}
			transparent
			maskClosable={false}
			title="提示"
			footer={[
				{
					text: '关闭页面',
					onPress: () => {
						closeWindow();
					}
				}
			]}>
			<div style={{ height: 60, overflow: 'scroll' }}>
				请同意“投图”版权平台授权
				<br />
				授权后才可进入
			</div>
		</Modal>
	);
};
